define('tabControl',['jquery'], function ($) {
  var tabMan  = {
    /*
    enumerateTabs:function() {
      function getTabStops(o, a, el) {
        // Check if this element is a tab stop
        if (el.tabIndex > 0) {
            if (o[el.tabIndex]) {
                o[el.tabIndex].push(el);
            } else {
                o[el.tabIndex] = [el];
            }
        } else if (el.tabIndex === 0) {
            // Tab index "0" comes last so we accumulate it seperately
            a.push(el);
        }
        // Check if children are tab stops
        for (var i = 0, l = el.children.length; i < l; i++) {
            getTabStops(o, a, el.children[i]);
        }

      }

      var o = [];
      var a = [];
      var allStops = [];
      // var activeEl = document.activeElement;

      getTabStops(o, a, document.body);

      for (var i = 0, l = o.length; i < l; i++) {
        if (o[i]) {
            for (var j = 0, m = o[i].length; j < m; j++) {
              allStops.push(o[i][j]);
            }
        }
      }
      for (var i = 0, l = a.length; i < l; i++) {
        allStops.push(a[i]);
      }

      // for ( var i = 0; i < allStops.length; i++) {
      //   console.log('ITEM:', allStops[i], 'index', allStops[i].tabIndex);
      // }

    //  console.log('allStops:', allStops);
    },
    */
    init:function() {
      // HELPER TO FIND FIRST INTERACTIVE / FOCUSABLE ELEMENT
      $.extend($.expr[':'], {
        focusable: function(el, index, selector) {
          return $(el).is('a, button, :input, [tabindex]');
        }
      });
      var self = this;
      // console.log('tabControl INIT:::');
      // NOT USING YET:
      // self.enumerateTabs();
      document.body.addEventListener('mousedown', function() {
        // console.log('   ::: USING MOUSE');
        self.usingMouse = true;
        self.usingKeys = false;
        // document.body.classList.add('using-mouse'); GLOBAL.
        // $('a,.btn,.btn-mini').addClass('using-mouse');
        $('btn,.btn-mini').addClass('using-mouse');
        $('a').not('.disclaimer-link').addClass('using-mouse');
        $('.site-nav-highlight').addClass('using-mouse');
        $('#main-wrapper-row').addClass('using-mouse');

        // $('#header-expand-button-inner').addClass('using-mouse');
        $('#expander').addClass('using-mouse');
        $('.carousel-prev').addClass('using-mouse');
        $('.carousel-next').addClass('using-mouse');
        $('.bx-pager-item').addClass('using-mouse');


        $('#all-offers .checkbox').addClass('using-mouse');
        $('ul.filters li button').addClass('using-mouse');
        $('.site-nav-zip').addClass('using-mouse');
        $('.site-nav-link-type-container span').addClass('using-mouse');

        $('.dk-selected').addClass('using-mouse');
        $('.checkbox').addClass('using-mouse');
        $('.favorite-button').addClass('using-mouse');
        $('.kbb-link').addClass('using-mouse');

        $('#grid-button').addClass('using-mouse');
        $('#list-button').addClass('using-mouse');
        $('.inpage-share-icon-wrap').addClass('using-mouse');
        $('.inpage-share-icon-wrap').addClass('using-mouse');

        // MODAL CLOSE BTN
        $('.modal-dialog .close-ground').addClass('using-mouse');
        // SLIDER
        $('.ui-slider .ui-slider-handle').addClass('using-mouse');
        // COMPARE LANDING:
        $('.compare-item .series').addClass('using-mouse');
        // INVENTORY LANDING:
        $('.vehicles li').addClass('using-mouse');
        $('#lg-tabs').addClass('using-mouse');
        // INVENTORY RESULTS:
        $('.card-content .expand-button').addClass('using-mouse');
        // document.body.classList.remove('using-keys');
        // ABOUT PAGE
        $('.about-socials li').addClass('using-mouse');
        // ICONS.
        $('.icon').addClass('using-mouse');
        // SLICK DOTS:
        $('.slick-dots li button').addClass('using-mouse');
        // ALL VEHICLES
        $('.all-vehicles-item').addClass('using-mouse');
        // MODULE SPECIFIC
        $('.module-slideshow .mod-next').addClass('using-mouse');
        $('.module-slideshow .mod-prev').addClass('using-mouse');
        $('.module-slideshow .slide-img').addClass('using-mouse');
        $('.module-list .dealer-detail-view').addClass('using-mouse');
        // TSS COMPONENT:
        $('.tss-component .slick-dots').addClass('using-mouse');
        $('.tss-component .slick-arrow').addClass('using-mouse');
        // SLP
        $('.input-label-div').addClass('using-mouse');
        $('.btn-radio-dot').addClass('using-mouse');
      });
      document.body.addEventListener('keydown', function() {
        // console.log('   ::: USING KEYBOARD activeElement:', document.activeElement);
        self.usingMouse = false;
        self.usingKeys = true;
        // document.body.classList.remove('using-mouse'); GLOBAL.
        // $('a,.btn,.btn-mini').removeClass('using-mouse');
        $('btn,.btn-mini').removeClass('using-mouse');
        $('a').not('.disclaimer-link').removeClass('using-mouse');

        $('.site-nav-highlight').removeClass('using-mouse');
        $('#main-wrapper-row').removeClass('using-mouse');

        // $('#header-expand-button-inner').removeClass('using-mouse');
        $('#expander').removeClass('using-mouse');
        $('.carousel-prev').removeClass('using-mouse');
        $('.carousel-next').removeClass('using-mouse');
        $('.bx-pager-item').removeClass('using-mouse');

        $('#all-offers .checkbox').removeClass('using-mouse');
        $('ul.filters li button').removeClass('using-mouse');
        $('.site-nav-zip').removeClass('using-mouse');
        $('.site-nav-link-type-container span').removeClass('using-mouse');

        $('.dk-selected').removeClass('using-mouse');
        $('.checkbox').removeClass('using-mouse');
        $('.favorite-button').removeClass('using-mouse');
        $('.kbb-link').removeClass('using-mouse');

        $('#grid-button').removeClass('using-mouse');
        $('#list-button').removeClass('using-mouse');
        $('.inpage-share-icon-wrap').removeClass('using-mouse');

        // MODAL CLOSE BTN
        $('.modal-dialog .close-ground').removeClass('using-mouse');
        // SLIDER
        $('.ui-slider .ui-slider-handle').removeClass('using-mouse');
        // COMPARE LANDING:
        $('.compare-item .series').removeClass('using-mouse');
        // INVENTORY LANDING:
        $('.vehicles li').removeClass('using-mouse');
        $('#lg-tabs').removeClass('using-mouse');
        // INVENTORY RESULTS:
        $('.card-content .expand-button').removeClass('using-mouse');
        // ABOUT PAGE
        $('.about-socials li').removeClass('using-mouse');
        // ICONS.
        $('.icon').removeClass('using-mouse');
        // SLICK DOTS:
        $('.slick-dots li button').removeClass('using-mouse');
        // ALL VEHICLES
        $('.all-vehicles-item').removeClass('using-mouse');
        // MODULE SPECIFIC
        $('.module-slideshow .mod-next').removeClass('using-mouse');
        $('.module-slideshow .mod-prev').removeClass('using-mouse');
        $('.module-slideshow .slide-img').removeClass('using-mouse');
        $('.module-list .dealer-detail-view').removeClass('using-mouse');
        // TSS COMPONENT:
        $('.tss-component .slick-dots').removeClass('using-mouse');
        $('.tss-component .slick-arrow').removeClass('using-mouse');
        // SLP
        $('.input-label-div').removeClass('using-mouse');
        $('.btn-radio-dot').removeClass('using-mouse');
      });
      // SKIP LINKS:
      // main-wrapper-row

      $('#skip-nav, #skip-footer-nav').keydown(function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          // BAT-4151 NEEDS TO BE FOCUSABLE (JQUERY custom function added above) AND visible, mobile and non mobile elements may co-exist.

          // HANDLE TAB IN FOR PE
          if (window.location.pathname.indexOf('payment-estimator') !== -1) {
            var iFrame = document.getElementById('pe-iframe');
            var tabInMethod = {
              method: 'tabIn'
            };
            if (iFrame && iFrame.contentWindow) {
              iFrame.contentWindow.postMessage(tabInMethod, '*');
            }
          } else {
            // TAB IN FROM SKIP LINKS FOR EVERYTHING:
            var firstInteractive = $('#main-wrapper-row').find(':focusable:visible').first();
            // console.log('firstInteractive ', firstInteractive);
            firstInteractive.focus();
          }

          var navHeight = $('.site-nav').outerHeight();
          var $mwr = $('#main-wrapper-row');
          var top = $mwr.offset().top - navHeight ;// -112;

          if ($(window).width() <= 768) {
            var headerheight = 50;//
            var nvbh = $('.nav-sticky').height() + headerheight;
            top += nvbh;// account for mobile nav bar
          }
          var time = 200;
          $('body, html').animate({
            scrollTop: top
          }, time);

        }
      });

      // BAT-3846 INCLUDED IN shared-templates.xsl see: template-offer-card
      // TODO: Take this off of window
      offerCardKeyDown = function(event) {
        if(event.keyCode === 32) {
          // KEYBOARD CONTROL TO GO TO OFFER DETAIL:
          event.preventDefault();
          if (event.target.href) {
            window.location.href = event.target.href;
          }
        }
        return;
      };
    }
  }
  return tabMan;
});

